import _defineProperty from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["deviceWidthRanges", "children"],
    _excluded2 = ["values", "width", "deviceWidthRanges", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import ResponsiveImport from 'react-responsive';
import { DeviceScreenWidthConsumer, DEFAULT_DEVICE_SCREEN_WIDTH_RANGES } from './DeviceScreenWidthContext.js';
var Responsive = ResponsiveImport.default || ResponsiveImport;

var detectMinMaxWidth = function detectMinMaxWidth(types, ranges) {
  if (types.indexOf('desktop') > -1 && types.indexOf('phone') > -1) {
    return {
      query: "(min-width: 0) and (min-width: ".concat(ranges['tablet'][1], "px), (max-width: ").concat(ranges['tablet'][0], "px)")
    };
  }

  return types.reduce(function (result, t) {
    // @ts-ignore
    var range = ranges[t];
    /* eslint-disable eqeqeq */

    return range ? {
      minWidth: range[0] == null ? result.minWidth : result.minWidth == null ? range[0] : Math.min(range[0], result.minWidth),
      maxWidth: range[1] == null ? undefined : result.maxWidth == null ? range[1] : Math.max(range[1], result.maxWidth)
    } : result;
    /* eslint-enable eqeqeq */
  }, {});
};
/**
 * Important Note:
 *
 * Having a structure like:
 * ```jsx
 * <div>
 *     <Device desktop>...</Device>
 *     <Device mobile>...</Device>
 *     <div>
 *         Some other content
 *     </div>
 * </div>
 * ```
 * may lead to an undefined behaviour on hydration. It's possible that content inside the `<Device>`
 *     component ends up in the div bellow or vice-verse.
 * To resolve this issue, wrap anything in `<Device>` in its own container:
 *
 * ```jsx
 *  <div>
 *    <Device desktop>...</Device>
 *    <Device mobile>...</Device>
 * </div>
 * ```
 */


var Device = /*#__PURE__*/function (_PureComponent) {
  _inherits(Device, _PureComponent);

  var _super = _createSuper(Device);

  function Device(props) {
    var _this;

    _classCallCheck(this, Device);

    _this = _super.call(this, props);
    _this.state = {
      show: _this.isInSameRange(props.width, props.initialWidth)
    };
    return _this;
  }

  _createClass(Device, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.state.show) {
        this.setState({
          show: true
        }); // eslint-disable-line
      }
    }
  }, {
    key: "isInSameRange",
    value: function isInSameRange(width, otherWidth) {
      var _this$props = this.props,
          deviceWidthRanges = _this$props.deviceWidthRanges,
          children = _this$props.children,
          props = _objectWithoutProperties(_this$props, _excluded);

      var isRenderProp = children instanceof Function;
      return width === otherWidth || Object.keys(deviceWidthRanges).filter(function (type) {
        // In case we use the render prop feature, we have to check all ranges.
        // Otherwise we unmount and mount again what yields to flickering / unnecessary load
        if (isRenderProp || type in props) {
          var range = deviceWidthRanges[type];
          return (// @ts-ignore
            (!range[0] || width >= range[0] && otherWidth >= range[0]) && ( // @ts-ignore
            !range[1] || width <= range[1] && otherWidth <= range[1])
          );
        }
      }).length > 0;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          values = _this$props2.values,
          width = _this$props2.width,
          deviceWidthRanges = _this$props2.deviceWidthRanges,
          children = _this$props2.children,
          props = _objectWithoutProperties(_this$props2, _excluded2); // @ts-ignore


      var types = Object.keys(deviceWidthRanges).map(function (type) {
        if (type in props) {
          // @ts-ignore
          delete props[type];
          return type;
        }
      }).filter(function (t) {
        return Boolean(t);
      });
      return (
        /* The initial possible re-rendering is required in case of attribute differences which will not be
        reapplied on the client, so we have to rerender the component when we detect changes.
        This can happen when we load the page on Desktop in the Mobile viewport for example */
        this.state.show && // @ts-ignore
        React.createElement(Responsive // TODO: fix lint error and remove line below
        // eslint-disable-next-line react-perf/jsx-no-new-object-as-prop
        , _objectSpread(_objectSpread(_objectSpread({
          // TODO: fix lint error and remove line below
          // eslint-disable-next-line react-perf/jsx-no-new-object-as-prop
          values: _objectSpread(_objectSpread({}, values), width ? {
            width: width
          } : this.state)
        }, types ? detectMinMaxWidth(types, deviceWidthRanges) : {}), props), this.state), function (matches) {
          return children instanceof Function ? children(matches) : matches && children;
        })
      );
    }
  }]);

  return Device;
}(PureComponent);

Device.defaultProps = {
  deviceWidthRanges: DEFAULT_DEVICE_SCREEN_WIDTH_RANGES
};

var DeviceWithConsumer = function DeviceWithConsumer(props) {
  return React.createElement(DeviceScreenWidthConsumer, null, function (consumerProps) {
    return React.createElement(Device, _objectSpread(_objectSpread({}, consumerProps), props));
  });
};

export default DeviceWithConsumer;
export var Phone = function Phone(props) {
  return React.createElement(DeviceWithConsumer, _objectSpread({
    phone: true
  }, props));
};
export var Tablet = function Tablet(props) {
  return React.createElement(DeviceWithConsumer, _objectSpread({
    tablet: true
  }, props));
};
export var Desktop = function Desktop(props) {
  return React.createElement(DeviceWithConsumer, _objectSpread({
    desktop: true
  }, props));
};